import React from 'react';
import { call, fork, put, takeEvery, all } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { UNIFIED_ALERT_METRICS } from '../../pages/constants/commonConstants';

import {
  getNSAlertDetailsListDataSuccess,
  getNSAlertDetailsListDataFail,
  NS_GET_ALERT_DETAILS_LIST_DATA,
  NS_GET_RUN_INSTANCE_RESULT_LIST,
  getNSRunInstanceResultListDataSuccess,
  getNSRunInstanceResultListDataFail,
  NS_GET_RUN_INSTANCE_SUMMARY,
  getNSRunInstanceSummaryDataSuccess,
  getNSRunInstanceSummaryDataFail,
  postNSHitsUserFeedbackSuccess,
  postNSHitsUserFeedbackFail,
  NS_POST_HITS_USER_FEEDBACK,
  NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE,
  getNSRIWatchListSuccess,
  getNSRIWatchListFail,
  NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE,
  getNSRIWatchListCoverageReportsSuccess,
  getNSRIWatchListCoverageReportsFail,
  NS_GET_RUN_INSTANCE_WHITELIST_INITIATE,
  getNSRIWhiteListSuccess,
  getNSRIWhiteListFail,
  NS_POST_DEPLOY_TO_PRODUCTION,
  postDeployToProductionSuccess,
  postDeployToProductionFail,
  NS_SAVE_RUN_INSTANCE,
  saveNSRunInstanceSuccess,
  saveNSRunInstanceFail,
  NS_POST_RUN_RUN_INSTANCE,
  postRunRunInstance,
  postRunRunInstanceSuccess,
  postRunRunInstanceFail,
  NS_GET_RUN_INSTANCE_VIEW_EXECUTION,
  getRunInstanceViewExecutionSuccess,
  getRunInstanceViewExecutionFail,
  getNSAlertDetailsListData,
  NS_GET_CUSTOMER_TYPE,
  getCustomerTypeSuccess,
  getCustomerTypeFail,
  NS_POST_CUSTOMER_TYPE,
  NS_PUT_CUSTOMER_TYPE,
  NS_DELETE_CUSTOMER_TYPE,
  postCustomerTypeSuccess,
  postCustomerTypeFail,
  putCustomerTypeSuccess,
  putCustomerTypeFail,
  deleteCustomerTypeSuccess,
  deleteCustomerTypeFail
} from '../../redux/actions/ns/runInstance';
import * as apiAlerts from '../../services/common';

import {
  getNSRunInstanceResultListService,
  getNSRunInstanceSummaryService,
  getAlertDetailsData,
  postHitsUserFeedbackService,
  getNSRIWatchListService,
  getNSRIWatchListCoverageReportsService,
  getNSRIWhiteListService,
  postDeployToProductionService,
  saveRunInstanceService,
  postRunRunInstanceService,
  getRunInstanceViewExecutionService,
  getCustomerTypeService,
  postCustomerTypeService,
  putCustomerTypeService,
  deleteCustomerTypeService
} from '../../services/ns/runInstance';

import { getMatchingConfigParametersData } from '../../redux/actions/ns/matchingConfig';

import { ROUTE_AMLS_SMART_SCREENING } from '../../pages/constants/globalConstants';

const networkLayerObjectAlert = new apiAlerts.NetworkLayer();

function* getAlertDetailDataWorker(payload) {
  try {
    const getAlertDetailResponse = yield call(getAlertDetailsData, payload);

    if (getAlertDetailResponse) {
      yield put(getNSAlertDetailsListDataSuccess(getAlertDetailResponse));
    }
  } catch (error) {
    yield put(
      getNSAlertDetailsListDataFail({
        message: 'Something went wrong, please try again..'
      })
    );
  }
}

export function* watchGetAlertDetailData() {
  yield takeEvery(NS_GET_ALERT_DETAILS_LIST_DATA, function* ({ payload }) {
    yield fork(getAlertDetailDataWorker, payload);
  });
}

/***
 * Run Instance Result
 ***/
function* getRunInstanceResultListDataWorker(payload) {
  const { COUNT_FOR_PAGINATION } = UNIFIED_ALERT_METRICS;
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const [response, count] = yield all([
      call(getNSRunInstanceResultListService, payload),
      call(
        networkLayerObjectAlert.amlsCommonUnifiedAlertCountsByMetricsNameAPI,
        {
          metricName: COUNT_FOR_PAGINATION,
          data: payload
        }
      )
    ]);

    yield put(
      getNSRunInstanceResultListDataSuccess({
        ...response,
        total: count?.count
      })
    );
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSRunInstanceResultListDataFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetRunInstanceResultListData() {
  yield takeEvery(NS_GET_RUN_INSTANCE_RESULT_LIST, function* ({ payload }) {
    yield fork(getRunInstanceResultListDataWorker, payload);
  });
}

/***
 * Run Instance Summary
 ***/
function* getRunInstanceSummaryDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSRunInstanceSummaryService, payload);
    yield put(getNSRunInstanceSummaryDataSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSRunInstanceSummaryDataFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetRunInstanceSummaryData() {
  yield takeEvery(NS_GET_RUN_INSTANCE_SUMMARY, function* ({ payload }) {
    yield fork(getRunInstanceSummaryDataWorker, payload);
  });
}

/***
 * Hits User Feedback
 ***/
function* postHitsUserFeedbackDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    yield call(postHitsUserFeedbackService, payload);
    yield put(postNSHitsUserFeedbackSuccess(payload.hitId));
    yield put(ga.fetchSuccess());
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp; Something went wrong !
        </p>
      ),
      description: 'Please try after sometime.'
    });

    yield put(postNSHitsUserFeedbackFail({ error: '' }));
    yield put(getNSAlertDetailsListData({ id: payload?.alertId }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchPostHitsUserFeedback() {
  yield takeEvery(NS_POST_HITS_USER_FEEDBACK, function* ({ payload }) {
    yield fork(postHitsUserFeedbackDataWorker, payload);
  });
}

/***
 * Run Instance WatchList
 ***/
function* getRIWatchListWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSRIWatchListService, payload);
    yield put(getNSRIWatchListSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSRIWatchListFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetRIWatchList() {
  yield takeEvery(
    NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE,
    function* ({ payload }) {
      yield fork(getRIWatchListWorker, payload);
    }
  );
}

//Watchlist Coverage and Reports
function* getRIWatchListCoverageReportsWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      getNSRIWatchListCoverageReportsService,
      payload
    );
    yield put(getNSRIWatchListCoverageReportsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSRIWatchListCoverageReportsFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetRIWatchListCoverageReports() {
  yield takeEvery(
    NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE,
    function* ({ payload }) {
      yield fork(getRIWatchListCoverageReportsWorker, payload);
    }
  );
}

/***
 * Run Instance WhiteList
 ***/
function* getRIWhiteListWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSRIWhiteListService, payload);
    yield put(getNSRIWhiteListSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSRIWhiteListFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetRIWhiteList() {
  yield takeEvery(
    NS_GET_RUN_INSTANCE_WHITELIST_INITIATE,
    function* ({ payload }) {
      yield fork(getRIWhiteListWorker, payload);
    }
  );
}

/**
 *  Deploy To Production
 **/
function* postDeployToProductionWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(postDeployToProductionService, payload);

    if (response?.status === 200 || response?.status === 201) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${payload?.championName} is promoted to champion successfully.`
      });
      yield put(postDeployToProductionSuccess(response.data));
      yield put(ga.fetchSuccess());
      window.location.reload();
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(postDeployToProductionFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchPostDeployToProduction() {
  yield takeEvery(NS_POST_DEPLOY_TO_PRODUCTION, function* ({ payload }) {
    yield fork(postDeployToProductionWorker, payload);
  });
}

/***
 * Save Run Instance
 ***/
function* SaveRunInstanceWorker(payload) {
  const { param, type } = payload;
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(saveRunInstanceService, param);
    if (response.status === 200 || response.status === 201) {
      yield put(saveNSRunInstanceSuccess(response.data));
      yield put(ga.fetchSuccess());
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${param?.name} is Saved successfully.`
      });
      if (type === 'RUN') {
        yield put(postRunRunInstance({ id: response.data, name: param.name }));
      }
      yield put(push(`${ROUTE_AMLS_SMART_SCREENING}/runInstance`));
    } else {
      throw { errorMessage: response.data.msg };
    }
  } catch (error) {
    yield put(saveNSRunInstanceFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
  }
}

export function* watchRunInstance() {
  yield takeEvery(NS_SAVE_RUN_INSTANCE, function* ({ payload }) {
    yield fork(SaveRunInstanceWorker, payload);
  });
}

/***
 * Run RunInstance
 ***/
function* postRunRunInstanceWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(postRunRunInstanceService, payload);

    if (response?.status === 200 || response?.status === 201) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${payload?.name} is successfully run.`
      });
      yield put(postRunRunInstanceSuccess(response.data));
      yield put(ga.fetchSuccess());
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(postRunRunInstanceFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchRunRunInstance() {
  yield takeEvery(NS_POST_RUN_RUN_INSTANCE, function* ({ payload }) {
    yield fork(postRunRunInstanceWorker, payload);
  });
}

/***
 * Run Instance - view executions
 ***/

function* getRunInstanceViewExecutionWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getRunInstanceViewExecutionService, payload);
    yield put(getRunInstanceViewExecutionSuccess(response.data));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getRunInstanceViewExecutionFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchRunInstanceViewExecution() {
  yield takeEvery(NS_GET_RUN_INSTANCE_VIEW_EXECUTION, function* ({ payload }) {
    yield fork(getRunInstanceViewExecutionWorker, payload);
  });
}

/***
 * GET Customer Type
 ***/

function* getCustomerTypeWorker() {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getCustomerTypeService);
    yield put(getCustomerTypeSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getCustomerTypeFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetCutsomerType() {
  yield takeEvery(NS_GET_CUSTOMER_TYPE, function* ({ payload }) {
    yield fork(getCustomerTypeWorker, payload);
  });
}

/***
 * POST Customer Type
 ***/

function* postCustomerTypeWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(postCustomerTypeService(payload));
    yield put(postCustomerTypeSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(postCustomerTypeFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchPostCustomerType() {
  yield takeEvery(NS_POST_CUSTOMER_TYPE, function* ({ payload }) {
    yield fork(postCustomerTypeWorker, payload);
  });
}

/***
 * PUT Customer Type
 ***/

function* putCustomerTypeWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(putCustomerTypeService(payload));
    yield put(putCustomerTypeSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(putCustomerTypeFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchPutCustomerType() {
  yield takeEvery(NS_PUT_CUSTOMER_TYPE, function* ({ payload }) {
    yield fork(putCustomerTypeWorker, payload);
  });
}

/***
 * DELETE Customer Type
 ***/

function* deleteCustomerTypeWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(deleteCustomerTypeService, payload);
    yield put(deleteCustomerTypeSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(deleteCustomerTypeFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchDeleteCustomerType() {
  yield takeEvery(NS_DELETE_CUSTOMER_TYPE, function* ({ payload }) {
    yield fork(deleteCustomerTypeWorker, payload);
  });
}
